import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Progression' })({
    root: {
        padding: 24,
        marginBottom: 24,
        marginRight: 24,
        height: 417,
        borderRadius: 28,
        border: '1px solid #EEEEEE',
        display: 'flex',
        flexDirection: 'column',
        '@media (max-width: 720px)': {
            marginRight: 0
        }
    },
    title: {
        fontWeight: 700,
        fontSize: 24
    },
    description: {
        fontSize: 14
    },
    menuItem: {
        textTransform: 'capitalize'
    },
    chart: {
        flex: 1
    },
    select: {
        height: 40
    }
});
